// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSurchargeBank_root__Sqg9-","text":"PlasmicSurchargeBank_text__Eqggm"};